/**
 * Vendor Heartbeat Hook
 * Sends periodic heartbeats to keep vendor status as 'online'
 */

import { useEffect } from 'react';
import { vendorApi } from '@/lib/api';
import { useVendorStore } from '@/store/vendor';
import { logger } from '@/lib/logger';

const HEARTBEAT_INTERVAL = 30000; // 30 seconds

export function useVendorHeartbeat() {
  const setStatus = useVendorStore((state) => state.setStatus);

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval>;

    const sendHeartbeat = async () => {
      try {
        await vendorApi.sendHeartbeat();
        setStatus('active'); // Sprint 27: Aligned with database enum
        logger.debug('Heartbeat sent successfully');
      } catch (error) {
        logger.error('Failed to send heartbeat', error as Error);
        // Don't set inactive immediately, allow a few failures
      }
    };

    // Send initial heartbeat
    sendHeartbeat();

    // Set up interval
    intervalId = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);

    // Cleanup
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [setStatus]);
}

